/**
 * Shared: Detect whether current runtime is Electron (main app / webview).
 *
 * This is cached because the environment does not change during app lifetime.
 */
let _isElectronCache: boolean | null = null;

const detectElectron = (): boolean => {
  if (typeof window === "undefined") return false;

  // 1) webview-preload usually injects electronBridge
  if ((window as any).electronBridge) return true;

  // 2) main preload injects electronAPI
  if ((window as any).electronAPI) return true;

  // 3) fallback via UA
  if (
    typeof navigator !== "undefined" &&
    /electron/i.test(navigator.userAgent)
  ) {
    return true;
  }

  return false;
};

export const useElectronEnvironment = (): boolean => {
  if (_isElectronCache === null) {
    _isElectronCache = detectElectron();
  }
  return _isElectronCache;
};

/** 非 React 场景（如 device-session heartbeat） */
export const getIsElectron = (): boolean => {
  if (_isElectronCache === null) {
    _isElectronCache = detectElectron();
  }
  return _isElectronCache;
};
